const SunRoof = () => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.3561 30.2451C16.6546 30.3053 13.4923 31.8888 11.4463 33.5685C9.47659 35.1856 8.83398 37.8121 8.83398 40.3606V43.8818C8.83398 44.9864 9.72942 45.8818 10.834 45.8818H16.4218M21.3561 30.2451C28.7054 30.1509 40.9551 30.2008 48.4786 30.2409C48.9717 30.2436 49.4474 30.064 49.8161 29.7367L52.826 27.0654M21.3561 30.2451L27.1906 23.121C28.3205 21.7414 30.0096 20.9414 31.7929 20.9414V20.9414M52.826 27.0654L53.4229 27.5937C54.4839 28.5328 55.7753 29.1732 57.1651 29.4495L59.5569 29.925C60.4928 30.111 61.1669 30.9324 61.1669 31.8866V41.0214C61.106 42.6415 60.9836 45.8818 56.9623 45.8818H54.7418M52.826 27.0654C52.826 27.0654 51.4731 25.3317 49.0877 22.9635C47.744 21.6295 45.9028 20.9414 44.0094 20.9414V20.9414M39.0193 30.2012V45.8818M25.7349 45.8818H39.0193M39.0193 45.8818H45.1511"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect x="56.0254" y="32.3682" width="3.05927" height="1.75497" rx="0.877485" fill="currentColor" />
    <rect x="33.8691" y="32.3721" width="3.06756" height="1.74664" rx="0.873321" fill="currentColor" />
    <path
      d="M55.1557 45.8822C55.1557 48.7136 52.8612 51.0085 50.0315 51.0085C47.2017 51.0085 44.9072 48.7136 44.9072 45.8822C44.9072 43.0507 47.2017 40.7559 50.0315 40.7559C52.8612 40.7559 55.1557 43.0507 55.1557 45.8822Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M26.3402 45.8822C26.3402 48.7136 24.0458 51.0085 21.216 51.0085C18.3862 51.0085 16.0918 48.7136 16.0918 45.8822C16.0918 43.0507 18.3862 40.7559 21.216 40.7559C24.0458 40.7559 26.3402 43.0507 26.3402 45.8822Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M37.9295 15.6254L37.9295 21.3244L37.9312 26.2568M37.9295 15.6254L36.1908 17.3646M37.9295 15.6254L39.6694 17.3646M37.9312 26.2568L39.6699 24.5176M37.9312 26.2568L36.1913 24.5176"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SunRoof;
